import React, { ReactNode } from 'react';
import classnames from 'classnames';

import styles from './flyout-item.css';

const FlyoutDivider = ({
  children,
  className,
  ...rest
}: {
  children?: ReactNode;
  className?: string;
}) => (
  <div className={classnames([styles.item, styles.divider, className])} {...rest}>
    {children}
  </div>
);

export default FlyoutDivider;
